import { fontWeight, themeGet } from '@pocketlaw/tetris';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
export const SearchResultContainer = styled.div `
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${themeGet('spacing.md')};
  padding-bottom: ${themeGet('spacing.lg')};
`;
export const resultItemStyle = css `
  display: flex;
  width: 100%;
  align-items: center;
  padding: ${themeGet('spacing.md')};
  gap: ${themeGet('spacing.md')};

  scroll-margin: ${themeGet('spacing.lg')};
`;
export const SkeletonItemContainer = styled.div `
  ${resultItemStyle}
`;
export const StyledLink = styled(Link) `
  ${resultItemStyle}
  text-decoration: none;

  ${({ $highlighted }) => $highlighted &&
    css `
      background-color: ${themeGet('colors.gray.25')};
      border-radius: ${themeGet('borderRadius.md')};
    `}
`;
export const Highlight = styled.strong `
  ${fontWeight('semibold')};
`;
